import axios from "axios";
export const APIURL = process.env.REACT_APP_API_ENDPOINT;

// CREATE =>  POST: register a new admin to the server
export function createAdmin(admin) {
	const result = axios.post(`${APIURL}/register`, admin);
	return result
}

// READ
export function getAllAdmins() {
  return axios.get(APIURL);
}

export function getAdminById(adminId) {
	return axios.get(`${APIURL}/find/${adminId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findAdmins(queryParams) {
  return axios.post(`${APIURL}/find`, { queryParams });
}

// UPDATE => PUT: update the admin on the server
export function updateAdmin(admin) {
  return axios.post(`${APIURL}/update/${admin.id}`, { admin });
}

// UPDATE Status
export function updateStatusForAdmins(ids, status) {
  return axios.post(`${APIURL}/updateStatusForAdmins`, { ids, status });
}

// DELETE => delete the admin from the server
export function deleteAdmin(id) {
 return axios.post(`${APIURL}/delete`, { id });
}

// DELETE Admins by ids
export function deleteAdmins(ids) {
  return axios.post(`${APIURL}/deleteAdmins`, { ids });
}
